import React, { useState } from 'react';

import { Input, Form, FormItem, SubmitButton, Button } from '../../components';
import type { LivekitServerUpdateRequest } from './useLiveKitServers';

type FormType = LivekitServerUpdateRequest;
type PartialFormType = Partial<LivekitServerUpdateRequest & { id: string }>;

type LiveKitSettingsFormProps = {
  setForm: (form: PartialFormType) => void;
  saving: boolean;
  form?: PartialFormType | null;

  onCancel: () => void;
  onSave: (form: FormType) => void;
};

export const LiveKitSettingsForm: React.FC<LiveKitSettingsFormProps> = ({
  form,
  saving,

  onSave,
  onCancel,
  setForm,
}) => {
  const { name, url, apiKey, apiSecret } = form ?? {};
  const isEdit = !!form?.id;
  const isValid = !!(name && url && apiKey && (isEdit || apiSecret));

  const handleSubmit = () => {
    console.log('form', form as FormType);
    if (!isValid) return;

    if (!apiSecret) {
      const { apiSecret: _omit, ...rest } = form ?? {};
      onSave(rest as FormType);
      return;
    }
    onSave(form as FormType);
  };

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form initialValue={form ?? {}} onChange={setForm}>
        <FormItem<PartialFormType>
          required
          name="name"
          label="Server Name"
          inline={false}
        >
          <Input withBorder placeholder="Enter server name" />
        </FormItem>

        <FormItem<PartialFormType>
          required
          name="url"
          label="Server URL"
          inline={false}
        >
          <Input withBorder placeholder="Enter server URL" />
        </FormItem>

        <FormItem<PartialFormType>
          required
          name="apiKey"
          label="API Key"
          inline={false}
        >
          <Input withBorder autoComplete="off" placeholder="Enter API key" />
        </FormItem>

        <FormItem<PartialFormType>
          required={!isEdit}
          name="apiSecret"
          label="API Secret"
          inline={false}
        >
          <Input
            withBorder
            type="password"
            autoComplete="new-password"
            placeholder={
              isEdit ? 'Leave empty to keep current secret' : 'Enter API secret'
            }
          />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="large"
            disabled={saving || !isValid}
            className="w-full"
            label={isEdit ? 'Update' : 'Create'}
            onClick={handleSubmit}
          />
          <Button
            size="large"
            type="light"
            label="Cancel"
            className="w-full"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};
